import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _PriceList } from "../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { BasicButton } from "../../theme/Component/BasicButton";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
interface Props {
    onChange: any;
    label?: string;
    selectFirstData?: boolean;
}

export const EditorPriceList = ({ onChange, label, selectFirstData }: Props) => {

    const { instance, lista, bean, setBean, setLista } = useDataBean(_PriceList);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [isActive, setisActive] = useState<any>(null)
    const [renderValue, setRenderValue] = useState<string>("");
    const [year, setYear] = useState<number>(_single.getCurrenYear())
    const [useYearFilter, setUseYearFilter] = useState<boolean>(false);
    const modal = useModal("Seleccione una Lista de Precios", MODAL_LG);

    useEffect(() => {
        if (year) {
            getLista();
        }
    }, [])

    useEffect(() => {
        if (selectFirstData && lista.length > 0) {
            const data = lista[0].DataBeanProperties;
            onChange(data);
            setRenderValue(`${data.IDPriceList} - ${data.Name}`)
        }
    }, [selectFirstData])

    const getLista = () => {
        instance.getPriceListCatalog(useYearFilter ? year : null, regexStr, isActive, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDPriceList', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Año', property: 'Year', visible: true, MASK_DATE },
        { title: 'Activo', property: 'IsActive', visible: true },
        { title: 'Código', property: 'Code', visible: true },

    ]

    const selectItem = () => {

        if (bean.IDPriceList) {
            setRenderValue(`${bean.IDPriceList}-${bean.Name}`)
            modal.close();
            onChange?.(bean)
        } else {
            toast.error("Lista de precios no valida")
        }
    }

    return (
        <>
            <label>{label ? label : 'Listado de Precios'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-6">
                        <YearSelector
                            value={year}
                            tittle="Vigencia"
                            onChange={(e) => {
                                setYear(e);
                                setUseYearFilter(true);
                            }}
                        />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicSwitch estado={isActive} label="Activo ?" eventChange={(e: any) => { setisActive(e) }}></BasicSwitch>
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15} />
                    </div>
                </div>
            </Modal>
        </>
    )
}